import { useContext } from 'react';

import {
  CalendarContext,
  type CalendarContextProps,
} from '../contexts/CalendarContext.js';

/**
 * @internal
 */
export const useCalendarContext = (): CalendarContextProps => {
  return useContext(CalendarContext);
};
